export default __webpack_public_path__ + "ace0c7ad4bf8ad3ffcbf5c55ce45ce12.svg";